<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-dialog v-model="orderTypeCheckDialog" persistent content-class="depositStartOption orderTypeDialog" style="max-width: 360px; width: 360px;">
      <v-card class="marketWrapper"  style="max-width: 360px; width: 360px;">
        <v-container style="max-width: 360px; width: 360px;">
          <v-card-text class="textSize__16">
            Handelt es sich um eine Haupt- oder Nachbestellung?
          </v-card-text>
          <v-btn @click="setOrderType(1)"
                 class="depositResetBtn">
            Hauptbestellung
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn  @click="setOrderType(2)"
                  class="depositContBtn">
            Nachbestellung
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        {{ !isLoading ? headerTitle : null }}
      </v-toolbar-title>

    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">
      <v-card>
        <v-container class="checkoutDetailsWrapper">
          <span>Lieferdatum wählen:</span>

          <v-dialog
              ref="dialog"
              v-model="modal"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="dateFormatted"
                  class="dateTextField"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  filled
                  rounded
                  dense
                  outlined
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="tempDate"
                class="deliveryDatePicker"
                locale="de"
                :first-day-of-week="1"
                :min="minDate"
                :allowed-dates="deliveryDays"
                :picker-date.sync="pickerDate"
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="modal = false"
              >
                Schließen
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="applyDate"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
          <span>Gesamtbetrag:</span>
          <span v-if="!getLoadingState">{{ getTotalPrice | parsePrice2Digits }} €</span>
          <v-skeleton-loader type="text" class="totalPriceCheckoutSkeleton" v-if="this.getLoadingState"></v-skeleton-loader>
          <span>netto & ggf. zzgl. Pfand</span>
        </v-container>
      </v-card>

      <div class="checkoutBtnWrapper">
        <v-btn class="agbBtn"
               @click="getAGB"
        >
          <Component :is="require(`@/assets/sideNav/imprint.svg`)"/>
          <span>AGB als PDF herunterladen</span>
        </v-btn>
        <v-btn
            @click="issueOrder(date)"
            :disabled="renderData.products.length === 0 || !frozenItemsValid || !validPrice"
            class="checkoutBtn"
            v-intersect="onIntersect"
        >
          <Component :is="require(`@/assets/checkout/checkout.svg`)"/>
          <span>Bestellung aufgeben</span>
        </v-btn>

        <div class="frozenInfoTxt">
          <span v-if="!isLoading && !frozenItemsValid" style="padding-bottom: 10px;">
            Du hast leider weniger als 5 Einheiten aus der Kategorie Tiefkühl bestellt -
            bitte ergänze Deine Bestellung dementsprechend (Aktuelle Einheiten: {{ frozenItemsCount }}).
          </span>
          <div style="height: 10px;" v-if="!isLoading && !validPrice"></div>
          <span v-if="!isLoading && !validPrice">
            Du hast leider den Mindestbestellwert von 500 € ohne Tabakwaren nicht erreicht -
            bitte ergänze Deine Bestellung dementsprechend.
          </span>
        </div>
      </div>

      <v-expansion-panels class="checkoutCartOverview"
                          flat accordion
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            Details zur Lieferung
          </v-expansion-panel-header>
          <v-divider/>
          <v-expansion-panel-content>
            <product-list :render-data="renderData" v-if="!isLoading && this.getCartContents.length <= 10" />
            <v-virtual-scroll v-if="!isLoading && this.getCartContents.length > 10"
                              class="cart_virtual-scroll" item-height="210"
                              :items="this.getCartContents" bench="3"
                              ref="vscroll"
            >
              <template v-slot:default="{index, item}">
                <v-card class="articleCard"
                        elevation="0"
                        light
                        :key="index"
                >
                  <v-list-item three-line @click="goToArticle(item.itemNo)">
                    <v-list-item-avatar tile>
                      <!--
                      <v-img :src="loadProductImage(item.itemNo)"
                             lazy-src=""
                             contain
                      >
                      -->
                      <v-img :src="baseUrl + 'storage/webps/'+ (item.itemNo.indexOf('-') > -1 ? item.itemNo.substr(0, item.itemNo.indexOf('-')) : item.itemNo)+'.webp'"
                             lazy-src=""
                             contain
                      >
                        <template v-slot:placeholder>
                          <v-skeleton-loader type="avatar" tile>

                          </v-skeleton-loader>
                        </template>
                      </v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-container>
                        <v-row class="articleCard__details">
                          <v-col cols="12"
                                 class="articleNameSmall textEllipsis"
                          >
                            {{ item.description }}
                          </v-col>
                          <div class="articleAdditionalInfoWrapper">
                            <v-col cols="12" v-if="renderData.cart || renderData.category || renderData.deposit" class="textSize__14 text--black pb-0 pt-2">
                              <span class="articleAdditionalInfo">Artikelnummer: {{ item.itemNo}}</span>
                            </v-col>
                          </div>
                          <v-col cols="12" v-if="item.availability === 'G' && !renderData.deposit" class="articleStatusCol">
                            <div class="articleAvailable"></div>
                            <span class="articleStatusAvailable">Artikel ist lieferbar</span>
                          </v-col>
                          <v-col cols="12" v-if="item.availability ==='R' && !renderData.deposit" class="articleStatusCol">
                            <div class="articleNotAvailable"></div>
                            <span class="articleStatusNotAvailable"
                                  v-if="!item.delisted"
                            >
                            Artikel ist derzeit nicht lieferbar
                          </span>
                            <span class="articleStatusNotAvailable"
                                  v-if="item.delisted"
                            >
                            Artikel ist ausgelistet
                          </span>
                          </v-col>
                          <v-col cols="12" v-if="item.availability==='Y'" class="articleStatusCol">
                            <div class="articlePending"></div>
                            <span class="articleStatusPending textEllipsis">Bestellartikel - wird nach Eintreffen automatisch ausgeliefert</span>
                          </v-col>

                          <v-col cols="9" v-if="!renderData.cart && !renderData.deposit">


                            <div class="discountRibbonWrap"
                                 v-if="item.price.length > 0 && item.price[0].action === 1"
                            >
                              <div class="discountRibbon">
                              </div>
                              <div class="discountRibbonContent">
                                <span class="ribbonText">Aktion</span>
                              </div>
                            </div>


                            <span class="articlePriceMain" v-if="item.price.length > 0 && item.price[0].price > 0">{{ item.price[0].price | parsePrice }} € </span>
                            <span class="articlePriceMain" v-if="item.price.length === 0 && item.default_price.uvp > 0">{{ item.default_price.uvp | parsePrice }} € </span>
                            <span class="articlePriceUVP" v-if="item.price.length > 0 && item.price[0].uvp !== null"> UVP: {{ item.price[0].uvp | parsePrice }} € </span>
                            <span class="articlePriceUVP" v-if="item.price.length > 0 && (item.price[0].uvp === null && item.default_price.uvp >0)"> UVP: {{ item.default_price.uvp | parsePrice }} € </span>
                            <span class="articlePriceUVP" v-if="item.price.length === 0 && (item.default_price.uvp !== null && item.default_price.uvp > 0)"> UVP: {{ item.default_price.uvp | parsePrice }} € </span>
                          </v-col>

                          <v-col cols="3">
                            <addToCart :article="item" class="listAddToCartFormButton" v-if="renderData.watchlist && (item.availability === 'G' || item.availability === 'Y')"/>
                          </v-col>

                          <v-col v-if="renderData.cart" cols="12" class="articleAmountCart">
                          <span v-if="item.itemNo.indexOf('-') !== -1">
                            {{ item.itemNo.substr(item.itemNo.indexOf('-')+1) * item.orderedAmount }}
                          </span>
                            <span v-else>
                            {{ item.orderedAmount }}
                          </span>
                            <span v-if="item.itemNo.indexOf('-') !== -1">
                            {{ item.orderedType | capitalize }}
                          </span>
                            <span v-else>
                            {{ item.orderedType | capitalize }}
                          </span>
                          </v-col>
                          <v-col v-if="renderData.cart" cols="12" class="pa-0">
                            <span class="articlePriceMain">{{ item.totalPriceArticle | parsePrice }} €</span>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-list-item-content>
                  </v-list-item>
                  <v-btn v-if="renderData.cart && !renderData.order" class="removeItem" @click="removeFromMyCart(index)">
                    <TrashCan/>
                  </v-btn>
                </v-card>
              </template>
            </v-virtual-scroll>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!--
      <v-expansion-panels class="checkoutCartOverview"
                          flat accordion
      >
        <v-expansion-panel  max-height="400">
          <v-expansion-panel-header>
            Details zur Lieferung
          </v-expansion-panel-header>
          <v-divider/>
          <v-expansion-panel-content>
            <product-list :render-data="renderData" v-if="!isLoading" />
          <v-container class="lastArticlesWrapper" v-if="isLoading">

            <v-row
                class="articleCardRow"
            >
              <v-col cols="12"
                     class="articleCardCol"
                     v-for="index in this.getCartContent"
                     :key="index"
              >
                <v-card class="articleCard"
                        elevation="0"
                        v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                        light
                >
                  <v-list-item three-line class="skeletonWrapper__li">
                    <v-skeleton-loader class="skeletonAvatar" type="avatar">

                    </v-skeleton-loader>

                    <v-list-item-content>
                      <v-container>
                        <v-row class="articleCard__details">
                          <v-col cols="12"
                                 class="articleNameSmall"
                          >
                            <v-skeleton-loader type="text"/>
                          </v-col>
                          <div class="articleAdditionalInfoWrapper">
                            <v-col cols="12" class="pb-0 pt-2">
                              <v-skeleton-loader type="text"/>
                            </v-col>
                          </div>
                          <v-col cols="12" class="articleStatus">
                            <v-skeleton-loader type="text"/>
                          </v-col>
                          <v-col cols="12" class="articleAmountCart">
                            <v-skeleton-loader type="text"/>
                          </v-col>
                          <v-col cols="12" class="pa-0 articlePrice">
                            <v-skeleton-loader type="text"/>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      -->
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapState, mapMutations} from "vuex"
import ProductList from "@/app/productListing/productList"
import axios from 'axios'
import jsonp from 'jsonp'
import chevron_up from "@/assets/chevron/chevron_up";
import TrashCan from "@/assets/cart/trashCan";
import {api} from "@/config/api";
import scrollToPreviousPositionMixin from "@/app/productListing/mixins/scrollToPreviousPositionMixin";
export default {
  name: "checkout",
  props: ['currentSelectedCartContentTypeProp'],
  mixins: [scrollToPreviousPositionMixin],
  components: {ProductList, chevron_up, TrashCan},
  data: vm => ({
    date: null,
    tempDate: null,
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0,10)),
    modal: false,
    isLoading: true,
    cartContent: null,
    renderData: {cart: true, category: false, checkout:true, products: []},
    same_day_orders_data: null,
    fallbackDeliveryDays: [1,2,3,4,5,6],
    deliveryDays: null,

    explicitDays: [],

    holiday: [],
    blockedDays: [],
    loadedYears: [],

    currentDay: null,
    pickerDate: null,

    frozenAmount: 0,
    tobaccoPrice: 0,
    currentSelectedCartContentType: null,

    orderTypeCheckDialog: false,

    baseUrl: api.url
  }),

  methods: {
    ...mapMutations({
      setCartDrawerState: 'setCartDrawerState'
    }),
    onIntersect(entries) {
      this.setTopScroll(!entries[0].isIntersecting)
    },

    goToArticle(artNr) {
      this.setScrollPositionRef()
      this.$router.push({name: 'Artikeldetails', params: {id: artNr}})
    },

    removeFromMyCart(data) {
      const artNr = this.getCartContents[data].itemNo
      const price = this.getCartContents[data].totalPriceArticle
      var articleDetails = {artNr: artNr}
      const snackTxt = {name: this.getCartContents[data].description, type:this.getCartContents[data].orderedType,  amount: this.getCartContents[data].orderedAmount}
      var removeData = [articleDetails, snackTxt]
      this.removeFromCart(removeData)
      this.updateTotalCartPrice(price)
      this.getCartContents.splice(data, 1)
    },

    loadProductImage(artNr) {
      let adjustedArtNr = null
      if (artNr.indexOf('-') === -1) {
        adjustedArtNr = artNr
      }
      else {
        adjustedArtNr = artNr.substr(0,artNr.indexOf('-'))
      }
      return 'api/pic/'+adjustedArtNr
    },

    formatDate(date) {
      if(!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    goBack() {
      this.$router.go(-1)
    },

    currentDayParser(date) {
      /** fallback für Bestellzeitraum, aktuell nicht genutzt*/
      /*
      if(date.getHours() > 9 ) {
        date.setDate(date.getDate() + 2)
      }
      else {
        date.setDate(date.getDate() + 1)
      }
      */

      let allowedDates = JSON.parse(this.allowedDates())
      //let nextAllowedDay = null

      if(allowedDates.length > 0) {
        for(let i = 0; i <= 6; i++) {
          date.setDate(date.getDate()+1)
          if(allowedDates.indexOf(date.getDay()) > -1 && date !== new Date()) {
            break
          }
        }
      }
      else {
        if(date.getDay() === 6) {
          date.setDate(date.getDate() + 2)
        }
        else {
          date.setDate(date.getDate() + 1)
        }
      }
      let dd = String(date.getDate()).padStart(2, '0')
      let mm = String(date.getMonth() + 1).padStart(2, '0')
      let yyyy = date.getFullYear()

      return yyyy + '-' + mm + '-' + dd
    },

    ...mapActions({
      retrieveCartContent: 'retrieveCartContent',
      setHeaderVisibility: 'setHeaderVisibility',
      setLoadingState: 'setLoadingState',
      issueOrder: 'issueOrder',
      removeFromCart: 'removeFromCart',
      updateTotalCartPrice: 'updateTotalCartPrice'
    }),

    ...mapState({
      allowedDates: 'allowedDates'
    }),

    ...mapMutations({
      setTopScroll: 'setTopScroll'
    }),

    getBlockedDays() {
      axios.get('/api/getExplicitDays')
          .then((response) => {
            this.blockedDays= response.data
            this.explicitDays = JSON.parse(response.data['delivery_days']['explicitDays'])

            return this.explicitDays
          })
    },

    generateAllowedDates(year) {
      let allowedDates = JSON.parse(this.allowedDates())

      if(!this.loadedYears.includes(year)) {
        this.loadedYears.push(year)
        jsonp( 'https://feiertage-api.de/api/?jahr='+ year +'&nur_land=BY', (error, data) => {
          if (error) {
            console.log(error)
          }
          else {
            for(let index in data) {
              if(index !== 'Augsburger Friedensfest') {
                this.holiday.push(data[index]['datum'])
              }
            }

            if(allowedDates.length > 0) {
              this.deliveryDays = val =>(this.holiday.indexOf(val) === -1 && allowedDates.includes(new Date(val).getDay()) || this.explicitDays.indexOf(val) !== -1 )
            }
            else {
              this.deliveryDays = val => (this.holiday.indexOf(val) === -1 && this.fallbackDeliveryDays.includes(new Date(val).getDay()) || this.explicitDays.indexOf(val) !== -1)
            }

          }
        });
      }
    },

    getAGB() {
      axios.get('api/agb', {
        headers: {
          'accept': 'application/pdf',
          'Content-Type': 'application/pdf',

        },
        responseType: 'arraybuffer'
      })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'AGB.pdf');
            document.body.appendChild(link);
            link.click();
          })
    },

    applyDate() {
      this.date = this.tempDate
      this.modal = false
    }
  },

  computed: {
    ...mapGetters({
      getCartContents: 'getCartContents',
      getCartContent: 'getCartContent',
      getTotalPrice: 'getTotalPrice',
      getLoadingState: 'getLoadingState',
    }),

    minDate() {
      return new Date().toISOString()
    },

    computedCurrentDay() {
      let today = new Date().toISOString()

      //if(this.explicitDays.length > 0 && this.holiday.indexOf(this.date) > -1) {
      if(this.explicitDays.length > 0) {
        let compatDays = this.explicitDays.concat(this.date)
        let firstAllowed =  compatDays.filter(val => val >= today).reduce(function (a, b) { return a < b ? a : b; })
        return firstAllowed
      }
      else {
        let firstAllowed = this.date
        return firstAllowed
      }
    },

    frozenItemsValid() {
      if(this.frozenItemsCount === 0) {
        return true
      }
      return this.frozenItemsCount >= 5
    },
    frozenItemsCount() {
      let frozenAmountSameDayOrder = this.same_day_orders_data?.frozenAmount ? this.same_day_orders_data?.frozenAmount : 0
      let frozenAmount = this.frozenAmount + frozenAmountSameDayOrder
      return frozenAmount
    },
    validPrice() {
      if(this.currentSelectedCartContentType === 2) {
        return true
        // return (this.getTotalPrice + this.same_day_orders_data.totalPrice) - this.tobaccoPrice - this.same_day_orders_data.tobaccoPrice > 500
      }
      return this.getTotalPrice - this.tobaccoPrice > 500
    },
    headerTitle() {
      if(this.currentSelectedCartContentType === 2) {
        return 'Nachbestellung aufgegeben'
      } else  {
        return 'Hauptbestellung aufgegeben'
      }
    }
  },

  mounted() {
    this.setHeaderVisibility(false)
    let explicits = this.getBlockedDays()
    this.currentDay = this.currentDayParser(new Date(), explicits)
    this.date = this.currentDay
    this.tempDate = this.date
    let year = this.currentDay.substr(0,this.currentDay.indexOf('-'))
    this.generateAllowedDates(year)
    this.retrieveCartContent(this.date).then((result) => {
      this.frozenAmount = result.data.frozenAmount
      this.tobaccoPrice = result.data.tobaccoPrice
      this.same_day_orders_data = result.data?.same_day_orders_date
      this.currentSelectedCartContentType = result.data.currentSelectedCartContentType
      this.isLoading = false
    })
  },

  watch: {
    explicitDays: {
      handler() {
        this.date = this.computedCurrentDay
      }
    },

    date: {
      handler(newVal, oldVal) {
        this.dateFormatted = this.formatDate(newVal)
        if(newVal !== oldVal) {
          this.isLoading = true
          this.retrieveCartContent(this.date).then((result) => {
            this.frozenAmount = result.data.frozenAmount
            this.tobaccoPrice = result.data.tobaccoPrice
            this.same_day_orders_data = result.data?.same_day_orders_date
            this.currentSelectedCartContentType = result.data.currentSelectedCartContentType
            this.isLoading = false
          })
        }
      }
    },

    getCartDrawerState: {
      handler(role) {
        if(role) {
          this.retrieveCartContent()

        }
        else if(!role) {
          this.setLoadingState(true)
        }
      }
    },

    getCartContents: {
      handler() {
        this.renderData.products = this.getCartContents
        this.setLoadingState(false)
      }
    },

    pickerDate: {
      handler(shownDate) {
        this.generateAllowedDates(shownDate.substr(0, shownDate.indexOf('-')))
      }
    }
  },
}
</script>

<style>
.priceInfoTxt {
  color: lightgrey;
  font-size: 12px;
}

.checkoutBtnWrapper {
  display: flex;
  flex-direction: column;
}

.checkoutBtnWrapper .v-btn {
  margin-top: 15px;
}

.checkoutBtnWrapper .v-btn:last-of-type {
  margin-bottom: 20px;
}

.agbBtn {
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.agbBtn .v-btn__content{
  color: var(--igros-black) !important;
  font-size: 12px;
}

.agbBtn svg {
  height: 25px;
  width: 35px;
}

.agbBtn .v-btn__content svg g {
  stroke: var(--igros-grey)!important;
  height: 47px!important;
}

.checkoutBtn {
  background-color: var(--igros-red) !important;
  margin-left: auto;
  width: 66%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 20px!important;
}

.checkoutBtn .v-btn__content svg {
  height: 27px;
  width: 40px;
}

.dateTextField {
  width: 100%!important;
}

.checkoutDetailsWrapper {
  padding: 15px 30px;
  display: flex;
  flex-direction: column;
}

.checkoutDetailsWrapper span:first-child{
  margin-right: auto;
  margin-bottom: 15px;
}

.checkoutDetailsWrapper span:last-child{
  margin-left: auto;
  font-size: 12px;
}

.checkoutDetailsWrapper span:nth-last-child(2){
  margin-left: auto;
  color: var(--igros-red);
  font-size: 22px;
  font-weight: bold;
}

.checkoutDetailsWrapper span:nth-last-child(3){
  margin-top: 15px;
  margin-left: auto;
  font-size: 16px;
}

.checkoutContent {
  padding-top: 15px;
}

.checkoutCartOverview.v-expansion-panels {
  z-index: 0;
  border-radius: 30px;
}

.checkoutCartOverview.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile) > .v-expansion-panel--active {
  z-index: 0;
  border-radius: 30px 30px 30px 30px!important;
}

.checkoutCartOverview > .v-expansion-panel--active > .v-expansion-panel-header {
  max-height: 48px!important;
  min-height: 48px!important;;
}

.checkoutCartOverview > .v-expansion-panel > .v-divider {
  display: none;
}

.checkoutCartOverview > .v-expansion-panel--active > .v-divider {
  display: revert;
}

.checkoutCartOverview .v-expansion-panel-content__wrap {
  padding: 0px!important;
}

.checkoutCartOverview .v-expansion-panel-content {
  max-height: 100vh;
  background-color: white;
  border-radius: 24px;
  overflow: hidden;
}
</style>
